//img
import pImg1 from "assets/images/products/32/img-1.png";
import pImg6 from "assets/images/products/32/img-6.png";
import pImg7 from "assets/images/products/32/img-7.png";
const rettingdetails = [
    {
        id: 1,
        ratting: 4.5,
        name: "Jansh Brown",
        date: "08 Mar, 2023",
        title: 'Product Quality',
        dic: '" This is an incredible framework worth so much in the right hands! Nowhere else are you going to get so much flexibility and great code for a few dollars. Highly recommend purchasing today! Like right now! "',
        image: [
            { id: 1, priview: pImg1, formattedSize: "7.87 KB", path: "img-1.png", size: '6000' },
            { id: 2, priview: pImg6, formattedSize: "5.87 KB", path: "img-6.png", size: '3000' },
            { id: 3, priview: pImg7, formattedSize: "7.00 KB", path: "img-7.png", size: '6800' },
        ]
    },
    {
        id: 2,
        ratting: 4.0,
        name: "Camilla Harber",
        date: "03 Mar, 2023",
        title: 'Product Quality',
        dic: " We have used your other templates as well and seems it's amazing with the design and code quality. Wish you best for the future updates. Keep updated you will be #1 in near future. ",
    },
    {
        id: 3,
        ratting: 5.0,
        name: "Kaylin Bechtelar",
        date: "28 Feb, 2023",
        title: 'Design Quality',
        dic: " This template is incredibly comprehensive considering how new and modern it is! I bought 8 different admin templates recently and all of them had some good features, but were always missing stuff that you only realise after purchase. I've migrated my site to this template and have yet to find anything missing or lacking! Plus, the online documentation is really easy to use and access and very comprehensive! Well done guys and thank you! ",
    },
    {
        id: 4,
        ratting: 3.5,
        name: "Dedrick Shields",
        date: "24 Feb, 2023",
        title: 'Feature Availability',
        dic: " Hello everyone, I would like to suggest here two contents that you could create. Course pages and blog pages. In them you could insert the listing and management of courses and listing and management of blog. The theme is perfect, one of the best purchases I've ever made. ",
    },
]
export { rettingdetails };
